import { Button, Modal, Form, Row, Col, message, Select } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleAssignAttendee } from "../../../api/training";
import { handleFetchCompanyUser, handleFetchUsers } from "../../../api/user";
import { useContext, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";

const { Option } = Select;

export default function AssignAttendee({
  isVisible,
  setVisible,
  training_id,
  courseRefetch,
}: any) {
  const { auth } = useContext(AuthContext);
  const [data, setData] = useState<any>({});
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { data: users }: any = useQuery({
    queryKey: ["users", auth?.company?._id],
    queryFn: () =>
      auth?.accessLevel === 7
        ? handleFetchUsers()
        : handleFetchCompanyUser({ _id: auth?.company?._id }),
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: handleAssignAttendee,
    onSuccess: () => {
      message.success("Assigned Successfully");
      form.resetFields();
      queryClient.invalidateQueries({
        queryKey: ["allTrainings", training_id],
      });
      courseRefetch();
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    if (data) {
      await mutate({ _id: training_id, data });
      setVisible(false);
    }
  };

  const handleSelected = async () => {
    const { user_id } = form.getFieldsValue();
    const selected = users?.payload?.filter(
      (item: any) => item?._id === user_id
    );
    if (selected) {
      setData({
        name: selected[0]?.name,
        email: selected[0]?.email,
        mobile: selected[0]?.mobile,
        company: selected[0]?.company,
        user: user_id,
        manager: auth?._id,
      });
    }
  };

  const userOptions = users?.payload?.map((level: any, index: number) => (
    <Option value={level?._id} key={index}>
      {level?.name}
    </Option>
  ));

  const clearForm = async () => {
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title="Assign Personel"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="assignPersonel"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="assignPersonel"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-row, justify-between"></div>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="user_id"
              label="Personel"
              rules={[
                {
                  required: true,
                  message: "Please select personel",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select Attendee"
                optionFilterProp="children"
                onSelect={() => handleSelected()}
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {userOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
